
<div class="background"></div>

<div class="container">
  <div class="empty-state fade-up">
    <img src="/public/images/forbidden-image.svg">
    <br/>
    <h2 class="m-0">{{'forbidden' | translate }}</h2>
    <p>
      {{'forbiddenMessage' | translate }}
    </p>
  </div>
</div>